import { language, market } from '../../configuration/index.js';

export function i18nSuffix() {
  return language == null || market == null || (language === 'fr' && market === 'FR') ? '' : `.${language}-${market}`;
}

export function translateFactory(keys) {
  return (key, ...args) => {
    if (keys[key] == null) return key;
    if (typeof keys[key] === 'object')
      return keys[key]['???']?.replaceAll(/\{(\d+)\}/g, (_, index) => (args[index] == null ? '' : args[index]));
    return keys[key].replaceAll(/\{(\d+)\}/g, (_, index) => (args[index] == null ? '' : args[index]));
  };
}
